import { Outlet, useLocation } from "react-router-dom";
import Navbar from "components/Navbar"; // ajusta el import según tu ruta real

export default function MainLayout() {
    const location = useLocation();
    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />
            <main className="p-4">
                <Outlet key={location.pathname} />
            </main>
        </div>
    );
}
